module.exports = __webpack_public_path__ + "static/whoops-screenshot-iphonex-2-4fa5061a42f551b1182c890e7de6a267.png";